import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Projects" },
  { to: "/invest-with-us", label: "Invest With Us" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  const navClass = ({ isActive }) =>
    `nav-link text-xs uppercase tracking-[0.18em] font-medium transition-colors duration-300 ${
      isActive ? "text-ink nav-link-active" : "text-graphite hover:text-ink"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-bone border-b border-ink/10" data-testid="site-header">
      <div className="container-x flex items-center h-20 md:h-24">
        <Link to="/" aria-label="Stelcore Development — home" data-testid="header-logo-link" className="shrink-0 mr-4 lg:mr-16">
          <Logo />
        </Link>
        <div className="ml-auto flex items-center gap-4">
          <button
            className="p-2 text-ink"
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-ink/10 bg-bone" data-testid="mobile-nav">
          <nav className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={navClass}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/invest-with-us#submit"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2"
              data-testid="mobile-cta-button"
            >
              Discuss Your Property
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
